import { render, staticRenderFns } from "./CheckpointBanner.vue?vue&type=template&id=6d670832"
import script from "./CheckpointBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckpointBanner.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CheckpointBanner.vue?vue&type=style&index=0&id=6d670832&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports